import MainCard from '@/components/MainCard';
import React, { useState, useEffect } from "react";
import { Modal, Select, Button, Spin, Tooltip } from "antd";
import {
  get_check_batch_clearance,
  get_completed_batch_details,
} from '@/utils/api';
import { useSelector, useDispatch } from "react-redux";
import { defaultColors } from '@/themes/antd-theme';

const BmrCheck = ({
  setIsBmrVisible,
  isBmrVisible,
  start_batch,
  batchId,
  set_batch_numberNew,
  batch_number,
  machine_id,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [Clearance, setClearance] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [currentProcessIndex, setCurrentProcessIndex] = useState(-1);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
  const getFinalStatus = (processes) => {
    return !processes.some((process) => process.status === false);
  };

  const [is_open, setIsOpen] = useState(false);
  const [bmr_product_list] = useState([]);
  const [bmr_product, set_bmr_product] = useState();
  const selectedModule = useSelector((state) => state.moduleView);
  const cancelBmr = () => {
    setIsBmrVisible(false);
    set_batch_numberNew("");
  };

  const runApiProcess = async (index) => {
    return new Promise((resolve) => {
      const success = true;
      resolve({
        success,
        error: null,
      });
    });
  };

  const runProcess = async (index) => {
    try {
      const result = await runApiProcess(index);

      setProcesses((currentProcesses) =>
        currentProcesses.map((process, idx) =>
          idx === index
            ? {
                ...process,
                status: result.success,
                error: result.error,
              }
            : process
        )
      );

      if (index < processes.length - 1) {
        setTimeout(() => {
          setCurrentProcessIndex(index + 1);
          runProcess(index + 1);
        }, 2000); // Delay of 2 seconds
      } else {
        setProcessingComplete(true);
        setCurrentProcessIndex(-1);
      }
    } catch (error) {
      setProcesses((currentProcesses) =>
        currentProcesses.map((process, idx) =>
          idx === index
            ? {
                ...process,
                status: false,
                error: "System check failed",
              }
            : process
        )
      );

      if (index < processes.length - 1) {
        setTimeout(() => {
          setCurrentProcessIndex(index + 1);
          runProcess(index + 1);
        }, 2000); // Delay of 2 seconds
      } else {
        setProcessingComplete(true);
        setCurrentProcessIndex(-1);
      }
    }
  };

  useEffect(() => {
    const startTimer = setTimeout(() => {
      setIsStarted(true);
      setCurrentProcessIndex(0);
      runProcess(0);
    }, 1000);

    return () => clearTimeout(startTimer);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        batch_number &&
          get_check_batch_clearance(
            { batch_number: batch_number, machine_id: machine_id },
            (response) => {
              console.log("Full API Response:", response.data);
              if (response.data && response.data) {
                const apiData = response.data;
                const processData = [
                  {
                    id: 1,
                    name: "Cleaning Status",
                    status: apiData.cleaning_status,
                    error: null,
                  },
                  {
                    id: 2,
                    name: "Employee Availability",
                    status: apiData.employee_availability,
                    error: null,
                  },
                  {
                    id: 3,
                    name: "Kitting Done",
                    status: apiData.kitting_done,
                    error: null,
                  },
                  {
                    id: 4,
                    name: "Machine Availability",
                    status: apiData.machine_availability,
                    error: null,
                  },
                ];
                setProcesses(processData);
              } else {
                setClearance([]);
              }
            }
          );
      } catch (e) {
        setError(e);
        console.error("Fetching data failed", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [machine_id, batch_number]);

  return (
    <>
      <Modal
        title="Line Clearance Status"
        open={isBmrVisible}
        footer={null}
        onCancel={cancelBmr}
      >
        {/* Header Row */}
        <div className="flex py-4 px-2">
          <div className="flex-1 text-lg font-medium">
            Modules
          </div>
          <div className="w-[150px] text-lg font-medium">
            Status
          </div>
        </div>

        {/* Process Rows */}
        <div className="mb-6 max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
          {processes.map((process, index) => (
            <div
              key={process.id}
              className="flex items-center border-b border-gray-100 py-4 px-2 hover:bg-gray-50"
            >
              <div className="flex-1 text-lg text-gray-700">
                {process.name}
              </div>
              <div className="w-[150px]">
                {!isStarted ? (
                  <div className="w-20" />
                ) : process.status === null && index === currentProcessIndex ? (
                  <Spin size="small" />
                ) : process.status !== null ? (
                  <Tooltip
                    title={process.status === false ? process.error : ""}
                    placement="left"
                  >
                    <div
                      className="inline-flex items-center py-1 px-3 rounded text-sm font-medium"
                      style={{
                        backgroundColor: process.status === true ? defaultColors.palette.green[50] : defaultColors.palette.red[50],
                        color: process.status === true ? defaultColors.success : defaultColors.error,
                      }}
                    >
                      {process.status === true ? "Ready" : "Not Ready"}
                    </div>
                  </Tooltip>
                ) : null}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <Button
            type="primary"
            disabled={!getFinalStatus(processes)}
            style={{
              backgroundColor: defaultColors.primary,
              borderColor: defaultColors.primary,
            }}
            onClick={() => {
              if (selectedModule === "prod") {
                start_batch(batchId);
                setIsBmrVisible(false);
              } else {
                setIsOpen(true);
              }
            }}
          >
            {selectedModule === "prod" ? "START" : "NEXT"}
          </Button>
        </div>
      </Modal>
      
      <Modal
        title="Select BMR Product"
        open={is_open}
        footer={null}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div className="space-y-4">
          <div>
            <label className="font-medium mb-1" htmlFor="product">
              {selectedModule === "prod" ? "Product" : "MBMR Product"}
            </label>
            <Select
              showSearch
              id="demo-select-small"
              value={bmr_product || undefined}
              size="large"
              style={{ width: "100%" }}
              placeholder="Select Bmr Product"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              dropdownStyle={{
                maxHeight: 400,
                overflow: "auto",
              }}
              onChange={(values) => {
                set_bmr_product(values);
              }}
            >
              {bmr_product_list?.map((bmr) => (
                <Select.Option
                  key={bmr?.batch_number}
                  value={bmr?.batch_number}
                >
                  {bmr?.batch_number}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              disabled={!bmr_product}
              style={{
                backgroundColor: defaultColors.primary,
                borderColor: defaultColors.primary,
              }}
              onClick={() => {
                start_batch(batchId, bmr_product);
                setIsBmrVisible(false);
                setIsOpen(false);
              }}
            >
              START
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BmrCheck;
